import React, { useState, useEffect } from "react";
import { useAlert } from "react-alert";
import axios from "axios";
import { APIURL } from "../../Global";
import { RiUserLine } from "react-icons/ri";
// import { FaCheck } from "react-icons/fa6";
// import { CgClose } from "react-icons/cg";
import "./plannedleaves.css";

const PlannedLeaves = () => {
    const [requests, setRequests] = useState([])
    const [reload, setReload] = useState(false)
    const alert = useAlert()

    useEffect(() => {
        const tokenString = sessionStorage.getItem("usertoken");
        let v2 = tokenString.replace(/["]+/g, "");

        axios
            .get(`${APIURL}/api/v1/service-provider/nurse-planned-leave/`, {
                headers: { Authorization: "Token " + v2 },
            })
            .then(res => {
                if (res.data.status === "success") {
                    const filteredRequests = res.data.details.filter((request) => request.is_approved === "pending");
                    setRequests(filteredRequests);
                } else {
                    setRequests([]);
                }
            })
            .catch((error) => { });
    }, [reload]);

    const updateStatus = (id, newStatus) => {
        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString?.replace(/["]+/g, "");

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        };
        axios
            .put(
                `${APIURL}/api/v1/service-provider/nurse-planned-leave/`,
                {
                    leave_id: id,
                    is_approved: newStatus,
                },
                { headers }
            )
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.status === "error") {
                        alert.error(res.data.message);
                    }
                    else {
                        alert.success(res.data.status)
                        setReload(!reload)
                    }
                }
            })
            .catch((err) => {
                console.error("Error updating leave status:", err);
                alert.error("Failed to update leave status.");
            });
    };

    const leaveOptions = [
        { value: "AL", label: "Annual Leave" },
        { value: "CL", label: "Casual Leave" },
        { value: "SL", label: "Sick Leave" },
        { value: "ML", label: "Maternity Leave" },
        { value: "marriage_leave", label: "Marriage Leave" },
        { value: "paternity_leave", label: "Paternity Leave" },
        { value: "bereavement_leave", label: "Bereavement Leave" },
        { value: "comp_off", label: "Compensatory Off" },
        { value: "LOP", label: "Loss Of Pay Leave" },
    ];

    const getLeaveLabel = (leaveType) => {
        const leave = leaveOptions.find((option) => option.value === leaveType);
        return leave ? leave.label : leaveType; // Fallback to the raw value if no match is found
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("default", { month: "long" });
        const year = date.getFullYear();
        return `${day} ${month}, ${year}`;
    };

    const calculateDays = (fromDate, toDate) => {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        const differenceInTime = to - from;
        const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24) + 1;
        return differenceInDays > 1 ? `${differenceInDays} days` : `${differenceInDays} day`;
    };

    return (
        <div>
            {requests?.map((request) => (
                <div className="leave-request-view" key={request.id}>
                    <div className="dis dir">
                        {/* <p className={`status ${leave.is_approved ? "approved" : "awaiting"}`}>{leave.is_approved ? "Approved" : "Pending"}</p> */}
                        <label className="leave-request-view-head">{getLeaveLabel(request.leave_type)} Request</label>
                        <label className="leave-request-view-dates">{formatDate(request.from_date)} - {formatDate(request.to_date)}</label>
                    </div>
                    <div className="dis" style={{ alignItems: "center" }}>
                        <div className="roster-profile col-2">
                            <div className="defaultprofile-nav" style={{ height: "50px", width: "50px" }}>
                                <RiUserLine style={{ fontSize: "20px" }} />
                            </div>
                        </div>
                        <div className="dis dir col-6">
                            <label style={{ textTransform: 'capitalize' }}>{request.nurse_name}</label>
                            <label>{calculateDays(request.from_date, request.to_date)}</label>
                            {request.remarks && <p className="category">{request.remarks}</p>}
                        </div>
                        <div className="col-2">
                            <div
                                className="approve-button"
                                onClick={() => updateStatus(request.id, "approved")} // Set status to "approved"
                            >
                                Approve {/* <FaCheck /> */}
                            </div>
                        </div>
                        <div className="col-2">
                            <div
                                className="approve-button reject-button"
                                onClick={() => updateStatus(request.id, "rejected")} // Set status to "rejected"
                            >
                                Reject{/* <CgClose /> */}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PlannedLeaves;
